export const checkDateBetween = (
  currentDate: Date,
  minDate: Date,
  maxDate: Date
): boolean => {
  const diffStartTime = currentDate.valueOf() - minDate.valueOf() >= 0;
  const diffEndTime = maxDate.valueOf() - currentDate.valueOf() >= 0;
  return diffStartTime && diffEndTime;
};
